import { debounce } from 'lodash';

import { NotifierType, showNotification } from '../notifier-item/notifier-item';
import { QUANTITY_SELECTOR_ERRORS } from './QuantitySelector.constants';

export const getValidator = (min?: number, max?: number) => {
    return (value: number): { errorCode: QUANTITY_SELECTOR_ERRORS | null } => {
        if (Number.isNaN(value)) {
            return { errorCode: QUANTITY_SELECTOR_ERRORS.INVALID };
        } else if (min !== undefined && value < min) {
            return { errorCode: QUANTITY_SELECTOR_ERRORS.MIN };
        } else if (max !== undefined && value > max) {
            return { errorCode: QUANTITY_SELECTOR_ERRORS.MAX };
        }

        return { errorCode: null };
    };
};

export const showError = debounce((title: string, message: string): void => {
    showNotification({ type: NotifierType.ERROR, title: title, description: message, duration: 3 });
}, 1000);
